<template>
  <div class="uk-alert-danger" uk-alert v-if="errors && errors.length">
    <p v-for="error in errors" :key="error.message">
      {{ error.message }}
    </p>
  </div>
</template>
<style lang="scss" scoped></style>
<script lang="ts">
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

export default class FormError extends Vue {
  @Prop({ type: Array, required: true }) errors: { message: string }[] = [];
}
</script>
